export default [
    '34 35',
    '<path d="M21.25 26L12.75 17.5L21.25 9" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>'
]